








































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component
export default class WebUserAuthCard extends Vue {
  @Prop({ default: false }) readonly separator!: boolean
  @Prop({ default: '' }) readonly title!: string
  @Prop({ default: '' }) readonly subTitle!: string
  @Prop({ default: '' }) readonly icon!: string
  @Prop({ default: false }) readonly flipped!: boolean

}
